"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocationType = void 0;
var LocationType;
(function (LocationType) {
    LocationType["GEO"] = "G";
    LocationType["ZIP"] = "Z";
})(LocationType = exports.LocationType || (exports.LocationType = {}));
//# sourceMappingURL=Location.js.map